export default {
  post_failed: 'FALHA',
  post_successfully: 'SUCESSO',
  images: {
    type: 'Indica qual o tipo de aplicação da imagem. Ex. Banner, Banner Responsivo, Poster, etc.',
    slug: 'Texto em formato de URL, letras minúsculas separadas por hifen, sem espaços, acentos ou caracteres especiais.',
    alt: 'Texto alternativo de imagem. Utilizado por leitores de tela e apresentado em caso de falha de carregamento.',
    image: 'Utilize imagens já otimizadas para web. Formatos PNG e JPG.',
  },
  persons: {
    type: 'Indica qual a atribuição do participante. Ex: Professor, Autor, etc',
    title:
      'Nome do participante. Aparecerá na listagem de particpantes do curso ou aula.',
    slug: 'Texto em formato de URL, letras minúsculas separadas por hifen, sem espaços, acentos ou caracteres especiais.',
    subtitle: 'Título do envolvido. Tamanho ideal: menos de 50 caracteres.',
    resume: 'Texto de biografia do envolvido. Tamanho ideal: 580 caracteres.',
    image: 'Utilize imagens já otimizadas para web. Formatos PNG e JPG.',
  },
  users: {
    ms1_access_level:
      'Indica qual a atribuição do usuário. Ex: Assinante, Administrador, etc',
    ms1_older_id: 'ID do usuário na plataforma antiga do MS.',
    can_use_trial: 'Usuário em período de 7 dias grátis.',
    name: 'Nome completo do usuário.',
    gender: 'Este campo é obrigatório.',
    email: 'Este campo é obrigatório.',
    verified_email: 'Usuário com e-mail já verificado.',
    password: 'Este campo é obrigatório.',
    phone: 'Telefone no padrão internacional. Ex. +5511999999999',
    nationality: 'Sigla do País',
    cpf: 'Número de CPF sem traços ou pontos. Campo necessário caso de nacionalidade seja Brasileira.',
    document:
      'Número do Documento sem traços ou pontos. Campo necessário caso de nacionalidade seja estrangeira.',
    street: 'Rua ou Street.',
    number: 'Número ou Number.',
    complement: 'Complemento ou Complement.',
    district: 'Bairro ou District.',
    city: 'Cidade ou City.',
    province: 'Sigla do estado em caso de endereço brasileiro ou Province.',
    country: 'Sigla do País ou Country.',
    zip_code:
      'Número de CEP sem traços ou pontos. ZIP Code em caso de estrangeiros.',
  },
  videos: {
    type: 'Indica qual o tipo de aplicação do vídeo.  Ex. Trailer, Aula, etc...',
    name: 'Título do vídeo. Aparecerá na lista de inclusão.',
    vimeo_id: 'ID fornecido pelo Vimeo.',
  },
  tags: {
    title:
      'Nome da tag. Aparecerá na listagem de tags do curso e na Bilbioteca.',
    slug: 'Texto em formato de URL, letras minúsculas separadas por hifen, sem espaços, acentos ou caracteres especiais.',
    description: 'Texto de descrição da Tag. Tamanho ideal: 220 caracteres.',
  },
  banner: {
    order: 'Ordem em que o banner aparecerá na página.',
    text_direction:
      'Posição do texto no banner em formato Desktop, alinhado à esquerda ou direita.',
    slug: 'Texto em formato de URL, letras minúsculas separadas por hifen, sem espaços, acentos ou caracteres especiais.',
    image_desktop: {
      type: '',
      order: 'Campo obrigatório.',
      path: 'Imagem horizontal. Utilize imagens já otimizadas para web. Formatos PNG e JPG.',
      alt: 'Texto alternativo de imagem. Utilizado por leitores de tela e apresentado em caso de falha de carregamento.',
    },
    image_mobile: {
      type: '',
      order: 'Campo obrigatório.',
      path: 'Imagem vertical. Utilize imagens já otimizadas para web. Formatos PNG e JPG.',
      alt: 'Texto alternativo de imagem. Utilizado por leitores de tela e apresentado em caso de falha de carregamento.',
    },
    mark: {
      type: 'Indica se o marker é opaco ou com borda.',
      text: 'Texto da Tag no topo do conteúdo.',
      text_color: 'Cor do texto interno da Tag.',
      color: 'Cor da borda da Tag.',
    },
    logo: {
      type: '',
      order: 'Campo obrigatório.',
      path: 'Utilize imagens já otimizadas para web. Formatos PNG e JPG.',
      alt: 'Texto alternativo de imagem. Utilizado por leitores de tela e apresentado em caso de falha de carregamento.',
    },
    title:
      'Texto do título. Aparecerá caso a logo não seja enviada e como texto alternativo.',
    subtitle: 'Texto do subtítulo, aparacerá abaixo da logo.',
    description: 'Texto de descrição do banner. Tamanho ideal: 200 caracteres.',
    text_color: {
      title: 'Cor do texto.',
      subtitle: 'Cor do texto.',
      description: 'Cor do texto.',
    },
    button: {
      type: 'Indica se o marker é opaco ou com borda.',
      order: 'Campo obrigatório.',
      text: 'Texto do botão. Tamanho ideal: duas a três palavras.',
      color: 'Cor de fundo do botão.',
      disabled: 'Texto do botão. Definido pela categoria.',
      text_color: 'Cor do texto no botão.',
      slug: 'Link do botão. Este link pode ser interno ou externo.',
    },
  },
  slider: {
    order: 'Ordem em que o banner aparecerá na página.',
    text_direction:
      'Posição do texto no banner em formato Desktop, alinhado à esquerda ou direita.',
    slug: 'Texto em formato de URL, letras minúsculas separadas por hifen, sem espaços, acentos ou caracteres especiais.',
    image_desktop: {
      type: '',
      order: 'Campo obrigatório.',
      path: 'Imagem horizontal. Utilize imagens já otimizadas para web. Formatos PNG e JPG.',
      alt: 'Texto alternativo de imagem. Utilizado por leitores de tela e apresentado em caso de falha de carregamento.',
    },
    image_mobile: {
      type: '',
      order: 'Campo obrigatório.',
      path: 'Imagem vertical. Utilize imagens já otimizadas para web. Formatos PNG e JPG.',
      alt: 'Texto alternativo de imagem. Utilizado por leitores de tela e apresentado em caso de falha de carregamento.',
    },
    mark: {
      type: 'Indica se o marker é opaco ou com borda.',
      text: 'Texto da Tag no topo do conteúdo.',
      text_color: 'Cor do texto interno da Tag.',
      color: 'Cor da borda da Tag.',
    },
    logo: {
      type: '',
      order: 'Campo obrigatório.',
      path: 'Utilize imagens já otimizadas para web. Formatos PNG e JPG.',
      alt: 'Texto alternativo de imagem. Utilizado por leitores de tela e apresentado em caso de falha de carregamento.',
    },
    title:
      'Texto do título. Aparecerá caso a logo não seja enviada e como texto alternativo.',
    subtitle: 'Texto do subtítulo, aparacerá abaixo da logo.',
    description: 'Texto de descrição do banner. Tamanho ideal: 200 caracteres.',
    text_color: {
      title: 'Cor do texto.',
      subtitle: 'Cor do texto.',
      description: 'Cor do texto.',
    },
    button: {
      type: 'Indica se o marker é opaco ou com borda.',
      order: 'Campo obrigatório.',
      text: 'Texto do botão. Tamanho ideal: duas a três palavras.',
      color: 'Cor de fundo do botão.',
      disabled: 'Texto do botão. Definido pela categoria.',
      text_color: 'Cor do texto no botão.',
      slug: 'Link do botão. Este link pode ser interno ou externo.',
    },
    button2: {
      type: 'Indica se o marker é opaco ou com borda.',
      order: 'Campo obrigatório.',
      text: 'Texto do botão. Tamanho ideal: duas a três palavras.',
      color: 'Cor de fundo do botão.',
      disabled: 'Texto do botão. Definido pela categoria.',
      text_color: 'Cor do texto no botão.',
      category: 'Categoria do botão (class ou live-class).',
      slug: 'Link do botão. Este link pode ser interno ou externo.',
    },
  },
  attachments: {
    type: 'Indica qual o tipo de aplicação do arquivo.  Ex. Ementa, Material Didático, Material Complementar etc...',
    complementary_type:
      'Indica qual o tipo de conteúdo será relacionado ao arquivo.  Ex. Estudo de Caso, Série, etc...',
    content_name: 'Nome do curso em formato slug. Ex. vint-cerf-the-archtect',
    content_type:
      'Número da seman e Nome da aula em formato de slug. Ex. 05-aula-como-escalar-seu-negocio',
    title: 'Título do anexo. Aparecerá no botão de download.',
    slug: 'Texto em formato de URL, letras minúsculas separadas por hifen, sem espaços, acentos ou caracteres especiais.',
    description:
      'Texto de descrição nos banners de material. Tamanho ideal: 240 caracteres.',
    path: 'Utilize preferencialmente arquivos em PDF ou Imagem.',
    url: 'Insira a URL do arquivo ou vídeo.',
  },
  stylesheet: {
    type: '',
    name: 'Nome  de identificação do curso ao qual o tema pertence.',
    primary: 'Cor dada aos botões e títulos do curso.',
    initial: 'Cor inicial do degradê de fundo do curso. Cor do topo do bloco.',
    final: 'Cor final do degradê de fundo do curso. Cor do fim do bloco.',
  },
  courses: {
    order: 'Ordem de listagem.',
    released_at:
      'Data de lançamento. Esta data será utilizada para verificar o acesso do cliente no seu período de contrato.',
    type: 'Tipo de conteúdo. Ex. Série ou Estudo de Caso.',
    title: 'Título do curso. Aparecerá no Banner e Título da Página.',
    slug: 'Texto em formato de URL, letras minúsculas separadas por hifen, sem espaços, acentos ou caracteres especiais.',
    autor_id:
      'Vincule uma pessoa como Autor. Caso ainda não exista crie um novo registro.',
    stylesheet_id:
      'Vincule um esquema de cores como Tema. Caso ainda não exista crie um novo registro.',
    poster: 'Utilize imagens já otimizadas para web. Formatos PNG e JPG.',
    banner:
      'Imagem horizontal. Utilize imagens já otimizadas para web. Formatos PNG e JPG.',
    banner_responsive:
      'Imagem horizontal. Utilize imagens já otimizadas para web. Formatos PNG e JPG.',
    banner_mobile:
      'Imagem vertical. Utilize imagens já otimizadas para web. Formatos PNG e JPG.',
    logo: 'Utilize imagens já otimizadas para web. Formatos PNG e JPG.',
    subtitle: 'Texto do nome da empresa.',
    description: 'Texto de descrição do banner. Tamanho ideal: 220 caracteres.',
    trailer_id:
      'Vincule um vídeo como Trailer. Caso ainda não exista crie um novo registro.',
    amendment_id:
      'Vincule um anexo como Ementa. Caso ainda não exista crie um novo registro.',
    summary: {
      title: 'Título do curso. Aparecerá no card da home.',
      subitle: 'Texto do subtítulo.',
      topics:
        'HTML dividido em items, na estrutura: <ul> <li> Tópico 1</li> <li>Tópico 2 </li> </ul>',
    },
    courseware: {
      image_desktop:
        'Utilize imagens já otimizadas para web. Formatos PNG e JPG.',
      image_mobile:
        'Utilize imagens já otimizadas para web. Formatos PNG e JPG.',
      description:
        'Texto de descrição do banner. Tamanho ideal: 240 caracteres.',
      attachment_id:
        'Vincule um anexo como Material Didático. Caso ainda não exista crie um novo registro.',
    },
    attachments_id:
      'Vincule um anexo como Material. Caso ainda não exista crie um novo registro.',
    weeks_id:
      'Vincule uma Semana. Caso ainda não exista crie um novo registro. As semanas listam as aulas (vídeos) na página do Curso.',
    extra_content_id:
      'Vincule uma Semana. Caso ainda não exista crie um novo registro. As semanas listam as aulas (vídeos) na página do Curso.',
    exercice_conclusion: {
      image: 'Utilize imagens já otimizadas para web. Formatos PNG e JPG.',
      title: 'Título da seção.',
      description:
        'Texto de descrição do banner. Tamanho ideal: 520 caracteres.',
      attachment_id:
        'Vincule um anexo como Material Didático. Caso ainda não exista crie um novo registro.',
    },
    involved_people_id:
      'Vincule uma Pessoa como participante. Caso ainda não exista crie um novo registro.',
    tags_id: 'Vincule uma Tag. Caso ainda não exista crie um novo registro.',
  },
  weeks: {
    id: 'ID do Curso/Série vinculado.',
    order: 'Ordem de listagem.',
    title:
      'Título da semana. Aparecerá na listagem de semanas na página do Curso.',
    slug: 'Texto em formato de URL, letras minúsculas separadas por hifen, sem espaços, acentos ou caracteres especiais.',
  },
  comments_question: {
    title:
      'Título da pergunta. Aparecerá acima da caixa de comentários na Aula.',
    slug: 'Texto em formato de URL, letras minúsculas separadas por hifen, sem espaços, acentos ou caracteres especiais.',
    description: 'Texto de descrição do banner. Tamanho ideal: 220 caracteres.',
  },
  quizzes: {
    lesson_id: 'Vincule um Checklist a uma Aula.',
    title: 'Texto da Pergunta. Tamanho ideal: 500 caracteres.',
    correct_option: 'Para respostas corretas insira uma razão.',
    order: 'Ordem de listagem.',
    value: 'Valor da resposta se correta para o calculo ao final.',
    description: 'Texto da Resposta. Tamanho ideal: 500 caracteres.',
    reason:
      'Texto da Justificativa. Este texto aparecerá quando o aluno verificar quais as respostas corretas. Tamanho ideal: 500 caracteres.',
  },
  lessons: {
    weeks_id:
      'Vincule uma Semana. Caso ainda não exista crie um novo registro.',
    order: 'Ordem de listagem.',
    released_at:
      'Data de lançamento da aula. Esta data também será utilizada para verificar o acesso do cliente no seu período de contrato.',
    type: 'Tipo de conteúdo. Ex. Aula, Liveclass, Documentário, etc.',
    slug: 'Texto em formato de URL, letras minúsculas separadas por hifen, sem espaços, acentos ou caracteres especiais.',
    title:
      'Título da aula. Aparecerá na listagem na página de Curso e Título da Página.',
    autor_id:
      'Digite uma parte do nome do protagonista do EC que você deseja vincular.',
    video_id:
      'Vincule um vídeo como Aula. Caso ainda não exista crie um novo registro.',
    description:
      'Texto aparecerá na página de vídeo e nas telas de detalhes da aula. Tamanho ideal: 500 caracteres.',
    summary: {
      summary: 'Sumário aparecerá na página de detalhes da aula.',
      title:
        'Título do sumário. Ex. O que você vai aprender? Aparecerá na página de detalhes da aula.',
      topics:
        'Adiciona um tópico ao sumário. Aparecerá na página de detalhes da aula.',
    },
    attachments_id: 'Permitido arquivos de até 800kb',
    checklist_id:
      'Vincule um checklist como Quiz. Caso ainda não exista crie um novo registro.',
    involved_people:
      'Digite uma parte do nome da Pessoa que você deseja vincular como Teacher.',
    tags_id: 'Vincule uma Tag. Caso ainda não exista crie um novo registro.',
    comments_question_id:
      'Vincule uma Pergunta. Caso ainda não exista crie um novo registro.',
  },
  marks: {
    type: 'Indica se o marker é opaco ou com borda.',
    text: 'Texto inserido no marker.',
    text_color: 'Cor do texto interno do marker.',
    default_color: 'Cor da borda ou fundo, dependendento do tipo.',
    direction: 'Posição do marker no Poster, alinhado à esquerda ou direita.',
  },
}
